import React from 'react';
import _ from 'lodash';
import { Button, Box, Stack, Typography, Chip, Paper } from '@mui/material';

const months = {
  1: 'Styczeń',
  2: 'Luty',
  3: 'Marzec',
  4: 'Kwiecień',
  5: 'Maj',
  6: 'Czerwiec',
  7: 'Lipiec',
  8: 'Sierpień',
  9: 'Wrzesień',
  10: 'Październik',
  11: 'Listopad',
  12: 'Grudzień'
};


export const SimpleView = props => {
  const { data, allCamps } = props;

  return (
    <Box component={Paper} sx={{ px: 4, py: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>Dostępny w miesiącach:</Typography>
      <Stack gap={2}>
        {data.months.sort((a, b) => a - b).map(item => <Chip key={item} variant="filled" color="primary" label={months[item]} />)}
      </Stack>
    </Box>
  );
};
